<template>
  <div v-if="factors.length > 0" class="p-4 mb-28">
    <FactorListItem
        v-for="factor in factors"
        :key="factor.factoR_ID"
        :factor="factor"
    />
  </div>
  <div v-else>
    <h1 class="text-center mt-[50%] text-gray-500 text-lg">فاکتوری موجود نیست</h1>
  </div>
</template>

<script>
import {getFactorList} from "@/API/API";
import FactorListItem from "@/components/User/FactorListItem";

export default {
  name: "FactorList",
  components: {FactorListItem},
  data() {
    return {
      factors: []
    }
  },
  async created() {
    this.factors = (await getFactorList()).data.result
  }
}
</script>

<style scoped>

</style>